// import { AstroPayConfig } from '@core/config';

import { ampli as Ampli, ApiKey, Event, EventOptions } from '@services/ampli';

export class AmplitudeTracker {
  public static init = (): void => {
    const apEnv = 'production'; // AstroPayConfig.getEnvironment();
    const isProd = apEnv === 'production';

    Ampli.load({
      environment: isProd ? 'production' : 'development',
      client: { apiKey: isProd ? ApiKey.production : ApiKey.development },
    });
  };

  public static trackEvent = (
    eventName: string | Event,
    properties?: Record<string, unknown>,
    options?: EventOptions,
  ): void => {
    if (typeof eventName === 'string') {
      Ampli.client.track(eventName, properties, options);
    } else {
      Ampli.track(eventName);
    }
  };

  public static cleanData = (): void => {
    Ampli.client.reset();
  };
}
